<template>
  <el-card class="ds-detail" style="position:relative;z-index:0;width:100%">
    <div slot="header" class="clearfix">
      <span>{{item.Name}}详情</span>
      <el-button @click="$router.back()" class="pull-right">
        <i class="fa fa-chevron-left fa-fw"></i> 返回
      </el-button>
    </div>
    <div style="margin-bottom: 15px;">
      <div class="border-style">软件信息</div>
      <table border="1" bordercolor="#dedede" style="width: 100%;border-collapse:collapse;">
        <tr>
          <th width="15%">软件名称</th>
          <td width="35%">{{item.Name}}</td>
          <th width="15%">分类</th>
          <td width="35%">{{item.Type}}</td>
        </tr>
        <tr>
          <th>最新发布日期</th>
          <td v-if="item.LatestVersion && item.LatestVersion.CreatedAt">
            {{item.LatestVersion.CreatedAt.substring(0,10)}}</td>
          <th>最新版本号</th>
          <td v-if="item.LatestVersion">{{item.LatestVersion.Version}}</td>
        </tr>
      </table>
    </div>
    <div style="margin-bottom: 10px;">
      <div class="border-style">版本记录</div>
      <el-timeline>
        <el-timeline-item placement="top" v-for="version in item.Versions" :key="version.ID">
          <el-card>
              <span style="color:#409EFF">版本{{version.Version}}</span>
              <span style="color:#cdcdcd;float:right;">{{version.CreatedAt.substring(0,10)}}</span>
            <p>{{version.UpdateLog}}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      item: {},
      itemList: [],
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      loading: false,
    };
  },
  mounted() {
    this.getItemData();
  },
  methods: {
    getItemData() {
      const params = {
        with: 'Versions',
      };
      this.$axios.get(`software/${this.$route.params.ID}`, { params }).then((response) => {
        this.item = response.data;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.ds-detail {
  .el-tabs__header {
    z-index: 0;
  }
  .fix-width {
    width: 120px;
  }
  table th td,
  table tr td {
    padding: 2px 5px;
    height: 30px;
    line-height: 30px;
  }
  table th {
    text-align: left;
    padding-left: 5px;
    color: #646566;
  }
  .border-style {
    height: 28px;
    line-height: 28px;
    border-radius: 0 15px 15px 0;
    border-left: 3px solid #cdcdcd;
    padding-left: 5px;
    margin-bottom: 10px;
    background-color: #ebf3f9;
    color: #646566;
  }
}
</style>
